import { Button, Icon } from "@outschool/backpack";
import { faCopy } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { useCopyLinkToClipboard } from "../../hooks/useCopyLinkToClipboard";

export function CopyOutreachLinkButton({
  variant = "contained",
  outreachShareUrl,
}: {
  variant?: "outlined" | "contained";
  outreachShareUrl: string;
}) {
  const { t } = useTranslation(
    "ui-components-website\\Outreach\\CopyOutreachLinkButton"
  );
  const { wasCopied, onCopy } = useCopyLinkToClipboard();

  const handleClick = async () => {
    await onCopy(outreachShareUrl);
  };

  return (
    <Button
      onClick={handleClick}
      variant={variant}
      fullWidth={true}
      startIcon={<Icon icon={faCopy} />}
      sx={{ width: "100%" }}
    >
      {wasCopied ? t`Copied!` : t`Copy OUTreach Link`}
    </Button>
  );
}
